<app-lazy-dropdown
    [label]="label"
    [control]="control"
    placeholder="Select University"
    [searchControl]="universityFilter"
    [items]="universityList"
    [totalCount]="totalUniversityCount"
    [offset]="universityOffset"
    [paginationLimit]="paginationLimit"
    (loadMore)="getNextUniversity()"
    (filterChange)="filterUniversity($event)"
    (selectionChange)="onSelectionChange($event)"
    [multiple]="multiple"
    [showClear]="showClear"
></app-lazy-dropdown>
